import React, { useState, useEffect, useRef } from "react";
import { RotateCw } from "lucide-react";
import './style.css';

const SearchDropdown = ({
  options = [],
  path,
  placeholder = "Buscar...",
  onSelect,
  forceReload,
  actionIcon = null,
  value = ""
}) => {
  const [query, setQuery] = useState(value);
  const [filtered, setFiltered] = useState(options);
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  // Update filtered options when options prop changes
  useEffect(() => {
    setFiltered(options);
  }, [options]);

  useEffect(() => {
    setQuery(value);
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    const filteredStartOptions = options.filter(option =>
      String(option[path] || "").toLowerCase().startsWith(value.toLowerCase())
    );
    const filteredOptions = options.filter(option =>
      !filteredStartOptions.includes(option) &&
      String(option[path] || "").toLowerCase().includes(value.toLowerCase())
    );
    setFiltered([...filteredStartOptions, ...filteredOptions]);
    setOpen(true);
  }

  const handleSelect = (option) => {
    setQuery(option[path]);
    setOpen(false);
    if (onSelect) onSelect(option);
  };

  return (
    <div ref={containerRef} className="search-dropdown-container">
      <div className="search-dropdown-input-wrapper">
        <input
          type="text"
          value={query}
          placeholder={placeholder}
          onChange={handleChange}
          onFocus={() => setOpen(true)}
          className={`search-dropdown-input ${forceReload ? 'with-action' : ''}`}
        />
        {forceReload && (
          <button
            type="button"
            className="search-dropdown-reload-btn-inner"
            onClick={forceReload}
            title="Recargar"
          >
            <RotateCw size={16} />
          </button>
        )}
      </div>

      {open && (
        <ul className="search-dropdown-list">
          {filtered.length > 0 ? (
            filtered.map((option, i) => (
              <li
                key={i}
                onClick={() => handleSelect(option)}
                className="search-dropdown-item"
              >
                {option[path]}
              </li>
            ))
          ) : (
            <li className="search-dropdown-empty">Sin resultados</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default SearchDropdown;
